import React, {Dispatch, SetStateAction, useState} from 'react';
import {
	RequestOrdersDataType,
	ResponseOrdersActivitiesType,
	ActivityInfoType,
} from '../../types/TypesUserOrders';
import s from './MyOrdersForManager.module.css';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import {useTranslation} from 'react-i18next';
import ShoppingTotal from '../../Components/ShoppingTotal/ShoppingTotal';
import OrdersActivitiesFilter from '../../Components/Filter/OrdersFilters/OrdersActivitiesFilter';
import AddFilterButton from '../../Components/Buttons/AddFilterButton';
import {useLazyOrderInfoQuery} from '../../redux/userOrdersApi';
import TableFullViewProductEl from '../../Components/TableCommonDirectory/TableElements/TableFullViewProductEl';

type Props = {
	data: ResponseOrdersActivitiesType;
	setFilters: Dispatch<SetStateAction<RequestOrdersDataType>>;
};

type ActivityRowProps = {
	activity: ActivityInfoType;
};

const ActivityRow: React.FC<ActivityRowProps> = ({activity}) => {
	const [isOpen, setIsOpen] = useState(false);
	const {t} = useTranslation();
	const [trigger, {data: orderInfo}] = useLazyOrderInfoQuery();

	const handleClickOpen = () => {
		if (!isOpen) {
			trigger(activity.id);
		}
		setIsOpen(!isOpen);
	};

	return (
		<div className={s.tableContainer}>
			<div className={s.tableSaleRow}>
				<div
					className={s.tableEl}
					role={'button'}
					tabIndex={0}
					onClick={handleClickOpen}
					style={{cursor: 'pointer'}}
				>
					{activity.id}
				</div>
				<div className={s.tableEl}>{activity.act_date}</div>
				<div className={s.tableEl}>{activity.points}</div>
				<div className={s.tableEl}>
					{activity.status === 'approved'
						? t('підтверджено')
						: t('відхилено')}
				</div>
				<div className={s.tableEl}>
					<button>{activity.client_name}</button>
				</div>
			</div>
			{isOpen && orderInfo && (
				<TableFullViewProductEl order={orderInfo as any} active={isOpen} />
			)}
		</div>
	);
};

const MyOrdersSale: React.FC<Props> = ({data, setFilters}) => {
	const [openFilter, setOpenFilter] = useState(false);
	const {t} = useTranslation();

	return (
		<>
			<div className={s.filterContainer}>
				<AddFilterButton
					setFilterMenu={setOpenFilter}
					filterMenu={openFilter}
					color={'blue'}
				/>
				<OrdersActivitiesFilter active={openFilter} setFilters={setFilters} />
			</div>
			<div className={s.tableGrid}>
				<GridTableHead
					columns={[
						'ID',
						t('Дата проведення'),
						t('Активність '),
						t('Статус '),
						t("І'мя клієнта"),
					]}
					gridTemplateColumns="2fr 2fr 2fr 2fr 2fr"
					customClassName={s.tableSaleRow}
				/>
				{data.activities.map((activity) => (
					<ActivityRow key={activity.id} activity={activity} />
				))}
				<div className={s.totalWrapper}>
					<ShoppingTotal
						count={data.count_orders}
						points={data.sum_points}
					/>
				</div>
			</div>
		</>
	);
};

export default MyOrdersSale;
